import { Link } from 'react-router-dom';

import 'view/components/Form/FormCheckbox.css';

export function phoneRequiresSmsOptIn(phone) {
	return Boolean(String(phone ?? '').trim());
}

export function isSmsOptInValid(phone, smsAlertsOptIn) {
	return !phoneRequiresSmsOptIn(phone) || smsAlertsOptIn;
}

export default function SmsAlertsOptInCheckbox({
	id,
	checked,
	onChange,
	disabled = false,
	className = '',
	showError = false,
}) {
	return (
		<div className={className}>
			<div className="form-checkbox-wrapper sms-alerts-opt-in">
				<input
					type="checkbox"
					className={`form-check-input ${showError ? 'is-invalid' : ''}`}
					id={id}
					checked={checked}
					onChange={onChange}
					disabled={disabled}
				/>
				<label className="form-check-label small" htmlFor={id}>
					By checking this box, I agree to receive recurring automated SMS alerts from Violerts about activity on my monitored properties at the number provided. Message frequency varies. Msg &amp; data rates may apply. Reply STOP to unsubscribe, HELP for help. See our{' '}
					<Link to="/sms-terms">SMS Terms</Link> and{' '}
					<Link to="/use-policy">Privacy Policy</Link>.
				</label>
			</div>
			{showError && (
				<div className="invalid-feedback d-block">
					You must agree to SMS alerts when providing a phone number.
				</div>
			)}
		</div>
	);
}
